@if (propertyViewModel?.securityAccess == null) {
  <nts-base-time-span-text-box
    #baseTimeSpanBox
    (onValueChange)="onValueChange($event)"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onFinishEditing)="onFinishEditing.emit($event)"
    [min]="propertyViewModel.metadataMinValue"
    [max]="propertyViewModel.metadataMaxValue"
    [initialChar]="initialChar"
    [isRequired]="!isNullable"
    [isDisabled]="isDisabled || !(propertyViewModel.isEnabled$ | async) || propertyViewModel?.securityAccess != null"
    [showErrorTooltip]="showErrorTooltip"
    [showErrorBorder]="showErrorBorder"
    [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
    [customCommandList]="customCommandsName"
    [listenClickOutside]="listenClickOutside"
    [tabIndex]="tabIndex"
    [showSeconds]="propertyViewModel.showSeconds"
    [showDays]="propertyViewModel.showDays"
    [value]="initialValue != null ? initialValue : propertyViewModel.value$ | async"
    (viewReady)="onBaseViewReady()"
    [placeholder]="placeholder">
  </nts-base-time-span-text-box>
} @else {
  <nts-base-security-text-box
    #baseSecurityTextBox
    (viewReady)="onBaseViewReady()"
    [accessMode]="propertyViewModel.securityAccess"
    [value]="propertyViewModel.formattedValue$ | async">
  </nts-base-security-text-box>
}


